// Vista previa: qué cursos ofrece la inscripción individual del instructor.
// - TODOS los publicados (como siempre).
// - SOLO los borradores creados por el propio instructor, para que valide su curso antes de
//   publicarlo sin exponer borradores ajenos.
// El archivado nunca se ofrece.
export function coursesForIndividualEnrollment<
  T extends { status: string; created_by?: number | null },
>(courses: T[], currentUserId: number | undefined): T[] {
  return courses.filter(
    (c) =>
      c.status === 'published' ||
      (c.status === 'draft' && currentUserId != null && c.created_by === currentUserId),
  );
}
